import type { EnvironmentData } from '../types/environment.types';

export const isLocalhost = window.location.hostname === 'localhost';

export const environment: EnvironmentData = {
  PUBLIC_URL: window.configuration.PUBLIC_URL,
  VERSION: window.configuration.VERSION,
  KEYCLOAK_URL: window.configuration.KEYCLOAK_URL,
  KEYCLOAK_CLIENT_ID: window.configuration.KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REALM: window.configuration.KEYCLOAK_REALM,
  API_URL: window.configuration.API_URL,
};
